module.exports = __webpack_public_path__ + "img/Jb.7a756b3d.png";